import Link from 'root/src/client/web/base/Link';
export function BottomText() {
    return <span className="text-center">For more help, join us in <DiscordLink />!</span>;
}
function DiscordLink() {
    return <Link href="https://discord.gg/x9ABQ8qcjS ">Discord</Link>;
}
